import {
  Box,
  Card,
  CardBody,
  CardProps,
  Skeleton,
  StatGroup,
  StatLabel,
  StatNumber,
  StatLabelProps,
  StatNumberProps
} from "@chakra-ui/react";
import { Overline } from ".";

function StatsCard({children, ...props}: CardProps) {
  return (
    <Card {...props}>
      <CardBody>
        <StatGroup display="flex" justifyContent="space-between">
          { children }
        </StatGroup>
      </CardBody>
    </Card>
  );
}

export default StatsCard;

export function Number({ children, ...props }: StatNumberProps) {
  return <StatNumber {...props}>{children}</StatNumber>;
}

export function Label({ children, ...props }: StatLabelProps) {
  return (
    <StatLabel {...props}>
      <Overline as="span">
        {children}
      </Overline>
    </StatLabel>);
}

export function LoadingStatsCard(){
  return (
    <Box display="flex" gap={2} flexDir="column" alignItems="end" textAlign="right" flex="initial">
      <Skeleton width={12} height={7} />
      <Skeleton width={16} height={3} />
    </Box>
  );
}
